import React from 'react';
import PropTypes from 'prop-types';
import Header from '../MainHeaderFooter/Header';
import Footer from '../MainHeaderFooter/Footer';
import PiracyNotice from '../../shared/PiracyNotice';

function HeaderFooterLayout({
  children,
  headerData,
  footerData,
  headerHTMLContent = null,
  footerHTMLContent = null,
  renderMode = { header: 'json', footer: 'json' },
  isHomePage = false,
  piracyNoticeHTML = null,
}) {
  return (
    <div className="w-full">
      {/* Header */}
      {renderMode?.header === 'html' && headerHTMLContent ? (
        <div
          className="w-full shadow-md sticky top-0 z-50 bg-white pt-2"
          dangerouslySetInnerHTML={{ __html: headerHTMLContent }}
        />
      ) : (
        <div className="w-full shadow-md sticky top-0 z-50 bg-white pt-2">
          <Header menuItems={headerData} />
        </div>
      )}

      {/* Content */}
      <section className="w-full flex justify-center bg-[#f7f8fa]">
        <div className={`${isHomePage ? '' : 'container'} w-full`}>
          {children}
        </div>
      </section>

      {/* Footer */}
      {renderMode?.footer === 'html' && footerHTMLContent ? (
        <div dangerouslySetInnerHTML={{ __html: footerHTMLContent }} />
      ) : (
        <div>
          <Footer footerData={footerData} />
        </div>
      )}

      {/* Sticky piracy notice — rendered after the footer so it stacks beneath
          it. It stays pinned to the bottom of the viewport while scrolling and
          settles below the footer at the very end of the page. */}
      {piracyNoticeHTML ? <PiracyNotice htmlContent={piracyNoticeHTML} /> : null}
    </div>

  );
}

export default HeaderFooterLayout;

HeaderFooterLayout.propTypes = {
  children: PropTypes.node,
  headerData: PropTypes.object,
  footerData: PropTypes.object,
  headerHTMLContent: PropTypes.string,
  footerHTMLContent: PropTypes.string,
  renderMode: PropTypes.shape({
    header: PropTypes.oneOf(['json', 'html']),
    footer: PropTypes.oneOf(['json', 'html']),
  }),
  isHomePage: PropTypes.bool,
  piracyNoticeHTML: PropTypes.string,
};
